import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import ProductDemo from './components/ProductDemo';
import ProductSection from './components/ProductSection';
import RefillBagsSection from './components/RefillBagsSection';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { CartProvider, useCart } from './components/CartContext';
import CartDrawer from './components/CartDrawer';

function FloatingCartButton() {
  const { totalItems, openCart } = useCart();
  if (totalItems === 0) return null;
  return (
    <button
      onClick={openCart}
      className="fixed bottom-6 right-6 z-30 flex items-center gap-2 bg-[#C4956A] hover:bg-[#b5845a] text-white font-bold px-5 py-3.5 rounded-full shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
    >
      <i className="ri-shopping-bag-line text-lg"></i>
      <span>Cart</span>
      <span className="bg-white text-[#C4956A] text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
        {totalItems}
      </span>
    </button>
  );
}

function HomePageInner() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <ProblemSolution />
        <ProductDemo />
        <ProductSection />
        <RefillBagsSection />
        <Testimonials />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
      <CartDrawer />
      <FloatingCartButton />
    </div>
  );
}

export default function HomePage() {
  return (
    <CartProvider>
      <HomePageInner />
    </CartProvider>
  );
}
